export default __webpack_public_path__ + "static/media/7.66a87ebf.mp3";